// extracted by css-extract-rspack-plugin
export default {"editorContainer":"Dkely","editor":"Jsta5","sidebar":"c5MAK"};